import { Heading, Icon } from '@assembly-js/design-system';
import clsx from 'clsx';
import React from 'react';

interface PageTitleMenuButtonProps {
  title: string;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
}

export const PageTitleMenuButton = React.forwardRef<
  HTMLSpanElement,
  PageTitleMenuButtonProps
>(({ title, onClick, className }, ref) => (
  <button
    type="button"
    onClick={onClick}
    className={clsx(
      'flex items-center max-w-full gap-2 p-1 px-2 rounded bg-transparent border-0 cursor-pointer hover:bg-primary-hover truncate -ml-2',
      className,
    )}
  >
    <span ref={ref} className="min-w-0">
      <Heading size="sm" className="truncate">
        {title}
      </Heading>
    </span>
    <Icon icon="ChevronDown" className="w-3 h-3 shrink-0 text-secondary" />
  </button>
));
PageTitleMenuButton.displayName = 'PageTitleMenuButton';
